import dayjs from 'dayjs'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import Avatar from '@components/Avatar'

export function FileRelatedUser({ user }) {
  return (
    <Stack direction="row" sx={{ gap: 1, py: 1, px: 2, backgroundColor: 'action.hover', borderRadius: 1, alignItems: 'center' }}>
      <Avatar variant="rounded" user={user} />
      <Stack>
        <Typography>
          {user.fullName}, {dayjs(user.dob).format('L')}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          MRN: {user.id}
        </Typography>
      </Stack>
    </Stack>
  )
}
